import { TCarouselSlideFields } from '../../@shared/galleryCarousel/types/mediaCarousel.types';
import { GalleryCarouselProps, TFullscreenCarouselFields } from '../types/fullScreenMediaGallery.types';

export class FullScreenMediaGalleryModel {
  private readonly fields?: TFullscreenCarouselFields | null;

  constructor(props: GalleryCarouselProps) {
    this.fields = props?.fields || null;
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }

  get carouselSlide(): Array<TCarouselSlideFields> {
    return (
      this.fields?.items?.map(({ fields }) => {
        return {
          fields: {
            description: fields?.description,
            useVideo: fields?.useVideo,
            editorialImageProps: {
              mobileImage: fields?.mobileImage,
              tabletImage: fields?.mobileImage,
              desktopImage: fields?.image,
              desktopTransformation: 'Size1900',
              tabletTransformation: 'Size1200',
              mobileTransformation: 'Size1200',
            },
            video: fields?.video,
          },
        };
      }) || []
    );
  }
}
